
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import { Action, Getter } from 'vuex-class';

import { getDateDiff } from './../../nmb/util';

@Component({
  components: {}
})
export default class Comments extends Vue {
  user: { [key: string]: any } = {};
  comments: string = '';
  newsId: string = '';
  remainWords: number = 500; // 还能输入的字符数
  placeholder: string = '请输入您对公告的评论...';
  replyParentID: number = 0; // 回复评论时的上一级ID
  getDateDiff: Function = getDateDiff;

  @Prop() commentsList: Array<{ [key: string]: any }>;
  @Prop() changeIsReload: Function;

  @Getter addNoticeCommentRes: { [key: string]: any };
  @Getter delNoticeCommentRes: { [key: string]: any };
  @Getter isNoticePermission: boolean;

  @Action getNoticeDetailById: (params: object) => void;
  @Action addNoticeComment: (params: object) => void;
  @Action delNoticeComment: (params: object) => void;
  @Action hasNoticePermission: (params: object) => void;

  created() {
    const { id } = this.$route.params;
    this.newsId = id;
    const user = localStorage.logonUser;
    if (!user) return false;
    this.user = JSON.parse(user);
    // 判断当前登录人是否有公告管理权限
    this.hasNoticePermission({});
  }

  get commentsListOrder(): any {
    return (
      this.commentsList &&
      this.commentsList.sort((a: any, b: any) => b.ID - a.ID)
    );
  }

  @Watch('$route.params.id')
  handleChangeRoute(val: string, oldVal: string) {
    this.newsId = val;
  }

  @Watch('addNoticeCommentRes.success')
  @Watch('delNoticeCommentRes.success')
  handleIsReload(val: boolean, oldVal: boolean) {
    if (val !== oldVal && val) {
      this.$emit('changeIsReload');
      this.getNoticeDetailById({
        newsId: this.newsId
      });
    }
  }

  delCommentFn(item: { [key: string]: any }) {
    if (this.user.UserGUID === item.CreateBy) {
      const warnText = item.SubComments.length
        ? '该评论下有回复， 删除评论回复将一起删除， 是否删除?'
        : '是否删除此评论?';
      this.$confirm(warnText, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delNoticeComment({
            commentId: item.ID
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
    }
  }

  cancelManagerReply() {
    this.placeholder = '请输入您对公告的评论...';
    this.replyParentID = 0;
  }

  managerReply(item: { [key: string]: any }) {
    this.placeholder = `回复: ${item.CreateUserName}`;
    this.replyParentID = item.ID;
    (this.$refs.commentinput as any).focus();
  }

  addCommentFn() {
    if (this.comments && this.comments.trim()) {
      if (this.comments.length > 500) {
        this.$alert('评论文字过长,  超过500字, 请修改后重新评论.', '提示', {
          confirmButtonText: '确定'
        });

        return;
      }
      this.addNoticeComment({
        ParentID: this.replyParentID,
        BizID: this.newsId,
        Content: this.comments,
        CreateUserName: this.user.UserName,
        CreateBy: this.user.UserGUID
      });
    } else {
      this.$message({
        message: '请输入评价',
        type: 'warning'
      });
    }
    this.comments = '';
    this.remainWords = 500;
    this.cancelManagerReply();
  }

  onChange(value: string) {
    this.remainWords = 500 - value.length;
  }
}
